"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "11",
  cy: "6",
  r: "2",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "16.6",
  cy: "17.6",
  r: "2",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "7",
  cy: "14",
  r: "2",
  opacity: ".3"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M7 10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m8-10c0-2.21-1.79-4-4-4S7 3.79 7 6s1.79 4 4 4 4-1.79 4-4m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m5.6 5.6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}, "3")], 'ScatterPlotTwoTone');